"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AverageAnnualYieldByPropertyType$ = exports.AverageAnnualYieldByPropertyType$outboundSchema = exports.AverageAnnualYieldByPropertyType$inboundSchema = void 0;
exports.averageAnnualYieldByPropertyTypeToJSON = averageAnnualYieldByPropertyTypeToJSON;
exports.averageAnnualYieldByPropertyTypeFromJSON = averageAnnualYieldByPropertyTypeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const statspropertytype_js_1 = require("./statspropertytype.js");
/** @internal */
exports.AverageAnnualYieldByPropertyType$inboundSchema = z.object({
    average_annual_yield: z.number(),
    property_type: statspropertytype_js_1.StatsPropertyType$inboundSchema,
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_annual_yield": "averageAnnualYield",
        "property_type": "propertyType",
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.AverageAnnualYieldByPropertyType$outboundSchema = z.object({
    averageAnnualYield: z.number(),
    propertyType: statspropertytype_js_1.StatsPropertyType$outboundSchema,
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageAnnualYield: "average_annual_yield",
        propertyType: "property_type",
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AverageAnnualYieldByPropertyType$;
(function (AverageAnnualYieldByPropertyType$) {
    /** @deprecated use `AverageAnnualYieldByPropertyType$inboundSchema` instead. */
    AverageAnnualYieldByPropertyType$.inboundSchema = exports.AverageAnnualYieldByPropertyType$inboundSchema;
    /** @deprecated use `AverageAnnualYieldByPropertyType$outboundSchema` instead. */
    AverageAnnualYieldByPropertyType$.outboundSchema = exports.AverageAnnualYieldByPropertyType$outboundSchema;
})(AverageAnnualYieldByPropertyType$ || (exports.AverageAnnualYieldByPropertyType$ = AverageAnnualYieldByPropertyType$ = {}));
function averageAnnualYieldByPropertyTypeToJSON(averageAnnualYieldByPropertyType) {
    return JSON.stringify(exports.AverageAnnualYieldByPropertyType$outboundSchema.parse(averageAnnualYieldByPropertyType));
}
function averageAnnualYieldByPropertyTypeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AverageAnnualYieldByPropertyType$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AverageAnnualYieldByPropertyType' from JSON`);
}
//# sourceMappingURL=averageannualyieldbypropertytype.js.map